/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { JobCreateStatus } from './jobCreateStatus';

export interface JobCreate {
  /**
     * @minLength 1
     * @maxLength 255
     */
  title: string;
  description?: string | null;
  project_id: string;
  job_manager_id: string;
  employer_id: string;
  status?: JobCreateStatus;
}
